/**
 * File Card Component
 *
 * Displays a card with file icon and download/open buttons.
 */

import { useTranslation } from 'react-i18next';
import { ExternalLinkIcon, DownloadIcon } from './Icons';

export interface FileCardProps {
  url: string;
  icon: React.ReactNode;
  label: string;
  openLabel: string;
}

export function FileCard({ url, icon, label, openLabel }: FileCardProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-lg border border-brand-beige p-6">
      <div className="flex items-center gap-4 mb-4">
        <div className="w-12 h-12 bg-brand-beige rounded-lg flex items-center justify-center flex-shrink-0">
          {icon}
        </div>
        <p className="text-sm text-brand-dark">{label}</p>
      </div>
      <div className="flex gap-3">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2 bg-brand-terracotta text-white text-sm font-medium rounded-md hover:bg-brand-terracotta-dark transition-colors"
        >
          <ExternalLinkIcon />
          {openLabel}
        </a>
        <a
          href={url}
          download
          className="inline-flex items-center gap-2 px-4 py-2 bg-brand-beige text-brand-dark text-sm font-medium rounded-md hover:bg-brand-beige-dark transition-colors"
        >
          <DownloadIcon />
          {t('courses.download')}
        </a>
      </div>
    </div>
  );
}
